<template>
    <div>
        <rkm-area
            background-color="primary"
            title="Desenvolvimento da criança"
            type="box"
        >
            <rkm-row>
                <rkm-col
                    v-if="!readonly"
                    class="my-auto"
                    cols="3"
                >
                    <rkm-button
                        @click="$refs.ModalMChatR.open(data.model.puericultura.questionarioMChatR)"
                        block

                        color="primary"
                    >
                        Calculadora M-CHAT-R
                    </rkm-button>
                </rkm-col>

                <rkm-col
                    :cols="readonly ? 12 : 9"
                    :class="`my-auto ${alertColor}`"
                >
                    <template v-if="hasResultado">
                        <strong>SCORE: {{resultado}}</strong>. {{alertMessage}}
                    </template>

                    <template v-else>
                        Nenhuma resposta registrada.
                    </template>
                </rkm-col>
            </rkm-row>

            <rkm-row class="mt-2">
                <rkm-col
                    v-if="!readonly"
                    class="my-auto"
                    cols="3"
                >
                    <rkm-button
                        @click="$refs.ModalAvaliacaoAlteracaoFenotipica.open(data.model.puericultura.alteracoesFenotipicas)"
                        block

                        color="primary"
                    >
                        Avaliar alterações fenotípicas
                    </rkm-button>
                </rkm-col>

                <rkm-col
                    :cols="readonly ? 12 : 9"
                    class="my-auto"
                >
                    <strong>Alterações fenotípicas:</strong>

                    <template v-if="alteracoesFenotipicasPresentes.length > 0">
                        {{alteracoesFenotipicasPresentes.map(alteracaoFenotipicaPresente => alteracaoFenotipicaPresente.descricao).join(', ')}}.
                    </template>

                    <template v-else>
                        Nenhuma alteração fenotípica presente.
                    </template>
                </rkm-col>
            </rkm-row>

            <rkm-row class="mt-2">
                <rkm-col
                    v-if="!readonly"
                    class="my-auto"
                    cols="3"
                >
                    <rkm-button
                        @click="$refs.ModalAvaliacaoFatorRisco.open(data.model.puericultura.fatoresRisco)"
                        block
                        color="primary"
                    >
                        Avaliar fatores de risco
                    </rkm-button>
                </rkm-col>

                <rkm-col
                    :cols="readonly ? 12 : 9"
                    class="my-auto"
                >
                    <strong>Fatores de risco:</strong>

                    <template v-if="fatoresRiscoPresentes.length > 0">
                        {{fatoresRiscoPresentes.map(fatorRiscoPresente => fatorRiscoPresente.descricao).join(', ')}}.
                    </template>

                    <template v-else>
                        Nenhum fator de risco presente.
                    </template>
                </rkm-col>
            </rkm-row>

            <rkm-area
                title="Marcos de desenvolvimento"
                type="fieldset"
                class="pb-0"
            >
                <rkm-row
                    v-for="(marcoDesenvolvimento, index) in data.model.puericultura.marcosDesenvolvimento"
                    :key="index"
                    class="mb-3"
                >
                    <rkm-col cols="12">
                        <rkm-list-group>
                            <rkm-list-group-item
                                class="rkm-list-group-item"
                                v-rkm-toggle="uniqueId(`rkm-collapse-${index}`)"
                            >
                                <rkm-row>
                                    <rkm-col
                                        class="align-self-center"
                                        cols="6"
                                    >
                                        <strong>{{marcoDesenvolvimento.descricao}}</strong>
                                    </rkm-col>

                                    <rkm-col
                                        class="align-self-center text-right"
                                        cols="6"
                                        style="font-size: 20px;"
                                    >
                                        <rkm-icon
                                            v-for="pergunta in marcoDesenvolvimento.perguntas"
                                            :key="pergunta.id"
                                            class="ml-1"
                                            v-bind="getIconProps(marcoDesenvolvimento, pergunta)"
                                        />
                                    </rkm-col>
                                </rkm-row>
                            </rkm-list-group-item>
                        </rkm-list-group>

                        <rkm-collapse
                            :id="uniqueId(`rkm-collapse-${index}`)"
                            class="rkm-collapse"
                        >
                            <rkm-table
                                :fields="getFields(marcoDesenvolvimento.showAlcancadoCom)"
                                :items="marcoDesenvolvimento.perguntas"
                                class="p-2"
                                hide-filters
                                hide-pagination
                            >
                                <template v-slot:cell(descricao)="{item}">
                                    {{item.descricao}}

                                    <rkm-icon
                                        :id="uniqueId(`marco-desenvolvimento-dica-${item.id}`)"
                                        icon="info-circle"
                                    />

                                    <rkm-popover
                                        :target="uniqueId(`marco-desenvolvimento-dica-${item.id}`)"
                                        triggers="hover"
                                    >
                                        {{item.dica}}
                                    </rkm-popover>
                                </template>

                                <template v-slot:cell(resposta)="{item}">
                                    <rkm-form-radio-group
                                        :disabled="readonly"
                                        v-model="item.isPresente"
                                    >
                                        <rkm-form-radio
                                            :disabled="item.isRespondido"
                                            :value="null"
                                        >
                                            Não informado
                                        </rkm-form-radio>

                                        <rkm-form-radio :value="false">Ausente</rkm-form-radio>
                                        <rkm-form-radio :value="true">Presente</rkm-form-radio>
                                    </rkm-form-radio-group>
                                </template>

                                <template v-slot:cell(alcancadoComAnos)="{item}">
                                    <rkm-form-input
                                        :disabled="!item.isPresente || readonly"
                                        :validations="getAnosValidations()"
                                        class="m-0"
                                        name="Alncançado com (anos)"
                                        number
                                        v-model="item.alcancadoComAnos"
                                    />
                                </template>

                                <template v-slot:cell(alcancadoComMeses)="{item}">
                                    <rkm-form-input
                                        :disabled="!item.isPresente || readonly"
                                        :validations="getMesesValidations(item)"
                                        class="m-0"
                                        name="Alncançado com (meses)"
                                        number
                                        v-model="item.alcancadoComMeses"
                                    />
                                </template>
                            </rkm-table>
                        </rkm-collapse>
                    </rkm-col>
                </rkm-row>
            </rkm-area>

            <p class="m-0">
                <rkm-icon
                    color="#8F8FA2"
                    icon="minus-circle"
                /> Não avaliado
                <rkm-icon
                    class="ml-1"
                    color="#40A42B"
                    icon="check-circle"
                /> Presente
                <rkm-icon
                    class="ml-1"
                    color="#E76F00"
                    icon="exclamation-triangle"
                /> Presente com atraso
                <rkm-icon
                    class="ml-1"
                    color="#F75B60"
                    icon="times-circle"
                /> Ausente
            </p>
        </rkm-area>

        <ModalAvaliacaoAlteracaoFenotipica
            :data="data"
            :readonly="readonly"
            ref="ModalAvaliacaoAlteracaoFenotipica"
        />

        <ModalAvaliacaoFatorRisco
            :data="data"
            :readonly="readonly"
            ref="ModalAvaliacaoFatorRisco"
        />

        <ModalMChatR
            :data="data"
            :readonly="readonly"
            ref="ModalMChatR"
        />
    </div>
</template>

<script>
// Components.
import ModalAvaliacaoAlteracaoFenotipica from './components/avaliacao-alteracao-fenotipica/Modal'
import ModalAvaliacaoFatorRisco from './components/avaliacao-fator-risco/Modal'
import ModalMChatR from './components/calculadora-m-chat-r/Modal'

export default {
    components: {
        ModalAvaliacaoAlteracaoFenotipica,
        ModalAvaliacaoFatorRisco,
        ModalMChatR,
    },
    computed: {
        alteracoesFenotipicasPresentes() {
            return this.data.model.puericultura.alteracoesFenotipicas.filter(alteracaoFenotipica => alteracaoFenotipica.isPresente)
        },
        fatoresRiscoPresentes() {
            return this.data.model.puericultura.fatoresRisco.filter(fatorRisco => fatorRisco.isPresente)
        },
        hasResultado() {
            return this.data.model && this.data.model.puericultura.questionarioMChatR
                .filter(model => model.resposta !== null).length > 0
        },
        resultado() {
            return this.data.model && this.data.model.puericultura.questionarioMChatR
                .filter(model => model.resposta !== null)
                .reduce((total, model) => total + (model.resposta ? model.valorRespostaSim : model.valorRespostaNao), 0)
        },
        alertColor() {
            let color = ''

            if (this.hasResultado && this.resultado >= 0 && this.resultado <= 2) {
                color = 'text-success'
            }
            else if (this.hasResultado && this.resultado >= 3 && this.resultado <= 7) {
                color = 'text-warning'
            }
            else if (this.hasResultado && this.resultado >= 8) {
                color = 'text-danger'
            }

            return color
        },
        alertMessage() {
            let message = ''

            if (this.resultado >= 0 && this.resultado <= 2) {
                if (this.data.form.paciente.idadeEmMeses < 24) {
                    message = 'Resultado classificado como Baixo risco pelo M-CHAT-R™. Instrumento de triagem, não diagnóstico. Recomenda-se reaplicação após a criança completar 24 meses, mantendo acompanhamento do desenvolvimento.'
                } else {
                    message = 'Resultado classificado como Baixo risco pelo M-CHAT-R™. Instrumento de triagem, não diagnóstico. Manter acompanhamento de rotina do desenvolvimento infantil.'
                }
            }
            else if (this.resultado >= 3 && this.resultado <= 7) {
                message = 'Resultado classificado como Risco moderado pelo M-CHAT-R™. Instrumento de triagem, não diagnóstico. Recomenda-se aplicação da entrevista de seguimento (M-CHAT-R/F) para refinamento do resultado e definição de conduta.'
            }
            else if (this.resultado >= 8) {
                message = 'Resultado classificado como Alto risco pelo M-CHAT-R™. Instrumento de triagem, não diagnóstico. Recomenda-se avaliação clínica e definição de conduta conforme rede assistencial.'
            }

            return message
        },
    },
    methods: {
        getFields(showAlcancadoCom) {
            const fields = [
                {key: 'descricao', label: 'Pergunta'},
                {key: 'status', label: 'Status'},
                {class: 'col-min', key: 'resposta', label: 'Resposta'},
            ]

            if (showAlcancadoCom) {
                fields.push({key: 'alcancadoComAnos', label: 'Alcançado com (anos)'})
                fields.push({key: 'alcancadoComMeses', label: 'Alcançado com (meses)'})
            }

            return fields
        },
        getIconProps(marcoDesenvolvimento, pergunta) {
            let props = {
                title: pergunta.descricao
            }

            if (pergunta.isPresente === null) {
                props.color = "#8F8FA2"
                props.icon = "minus-circle"
            } else if (pergunta.isPresente) {
                const alcancadoMeses = (pergunta.alcancadoComAnos * 12) + pergunta.alcancadoComMeses

                if (marcoDesenvolvimento.showAlcancadoCom && alcancadoMeses > marcoDesenvolvimento.mesesFinal) {
                    props.color = "#E76F00"
                    props.icon = "exclamation-triangle"
                } else {
                    props.color = "#40A42B"
                    props.icon = "check-circle"
                }
            } else {
                props.color = "#F75B60"
                props.icon = "times-circle"
            }

            return props
        },
        getAnosValidations() {
            return {
                required: true,
                min_value: 0,
                max_value: this.data.additionals.paciente.idadeAnos,
                max: 2,
            }
        },
        getMesesValidations(pergunta) {
            let maxValueIdadeMeses = 12

            if (pergunta.alcancadoComAnos == this.data.additionals.paciente.idadeAnos) {
                maxValueIdadeMeses = this.data.additionals.paciente.idadeMeses
            }

            return {
                required: true,
                min_value: 0,
                max_value: maxValueIdadeMeses,
                max: 2
            }
        },
    },
    props: {
        data: {type: Object, required: true},
        readonly: {type: Boolean, default: false},
    },
}
</script>

<style scoped>
.rkm-list-group-item {
    padding: 0.75rem 1.25rem;
}
.rkm-list-group-item:focus {
    outline: none;
}
.rkm-list-group-item:first-child {
    border-radius: 0;
}
.rkm-list-group-item:last-child {
    border-radius: 0;
}
.rkm-list-group-item > .row {
    margin: 0;
}
.rkm-collapse {
    border-bottom: 1px solid rgba(0, 0, 0, .15);
    border-left: 1px solid rgba(0, 0, 0, .15);
    border-right: 1px solid rgba(0, 0, 0, .15);
}
</style>